import { render, staticRenderFns } from "./contributionNew.vue?vue&type=template&id=28071b46&"
import script from "./contributionNew.vue?vue&type=script&lang=js&"
export * from "./contributionNew.vue?vue&type=script&lang=js&"
import style0 from "./contributionNew.vue?vue&type=style&index=0&id=28071b46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports